<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" field-readonly :is-print="isPrint" :vislbleAlert="true" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!-- 점검정보 -->
    <write-grid-container title="점검정보" v-model="form.점검정보" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.점검정보[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <vs-select v-if="dataType === 'selector'" class="w-full" autocomplete v-model="form.점검정보[value]">
            <vs-select-item v-for="item in ['리스크진단', '기타']" :text="item" :value="item" :key="item" />
          </vs-select>
          <date-selector v-else-if="dataType === 'date'" class="w-full" v-model="form.점검정보[value]" />
          <EcoFlowSelector v-else-if="dataType === 'eco'" v-model="form.점검정보[value]" />
          <ml-input v-else class="w-full" v-model="form.점검정보[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import ecoFlow from "@/views/boards/single-page/850/ecoFlow";
import EcoFlowSelector from "@/views/boards/single-page/850/EcoFlowSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
    EcoFlowSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    ecoFlow() {
      return ecoFlow;
    },
    selectEcoFlowId() {
      return this.$route.query.p;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        점검정보: {},
        점검내용: "",
        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["selector", "string"],
        labels: ["점검종류", "제목"],
        values: ["점검종류", "제목"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    if (this.selectEcoFlowId) {
      this.form.시설정보.공정명 = this.selectEcoFlowId;
    }

    // 사업장 정보를 고정시킨다 (953: 당진공장)
    if (!this.postId) {
      this.form.stdInfo.field_name = "당진공장";
      this.form.stdInfo.field_id = 953;
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
